import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


/* This view is used make bootstrap dropdowns work like normal dropdowns */

export default Backbone.View.extend({
  events: {
    'click ul li': 'select_item'
  },

  initialize: function (options) {
    _.bindAll(this, 'select_item', 'set_selected', 'set_selected_value',
      'get_selected_value');

    this.params = options;
    this.caret = '<span class="caret">';
    this.selected_button = $('a.dropdown-toggle', this.el);
    this.selected_item = $('ul li.active', this.el);
    var name = this.$el.data('name');
    this.select = $('select[name="' + name + '"]', this.$el.parent());
    if (this.params.selected) {
      this.set_selected_value(this.params.selected);
    }
    // Store this view in the element
    this.$el.data('dropdown-view', this);
  },

  select_item: function (e) {
    this.set_selected($(e.target));
  },

  set_selected: function (selected) {
    $('ul li.active', this.el).removeClass('active');
    this.selected_item = selected;
    this.selected_item.addClass('active');
    this.selected_button.html(this.selected_item.html() + this.caret);
    var value = this.selected_item.data('value');
    var html = $.trim(this.selected_item.html());
    // Select the option of the actual select (if it exists) for form
    // submission.
    if (this.select.length) {
      $('option[selected]', this.select).prop('selected', false);
      // Select only the item with the same html (may be multiple items with the same value)
      _.each($('option[value="' + value + '"]', this.select), function (new_select) {
        var $new_select = $(new_select);
        if (html == $.trim($new_select.html())) {
          $new_select.prop('selected', true);
        }
      });
    }
    this.trigger('selected', value);
  },

  set_selected_value: function (value) {
    // This should not be used when multiple items have the same value
    var select_el = $('ul li[data-value="' + value + '"]', this.el);
    if (select_el.length > 0) {
      this.set_selected(select_el);
    }
  },

  get_selected_value: function () {
    return this.selected_item.data('value');
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/views/dropdown.js
// module id = 12
// module chunks = 0